var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0 pt-3"},[_c('div',{staticClass:"chart-wrap"},[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"170px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }